import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'

import Sidebar, { menuItemShape } from './Sidebar'

import Section from 'components/page/Section'
import SubSection from 'components/page/Section/SubSection'
import AdditionalResources from 'components/blog/AdditionalResources'

const NoOverflowSection = styled(Section)`
  &&& {
    overflow: unset;
  }
`

export const SidebarContainer = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'row'],
})``

export const ChildrenContainer = styled(Box).attrs({
  pl: [0, 0, 20, 40, 50],
  width: [1, 1, 0.6],
})`
  box-sizing: content-box;
  z-index: 10;
`

function SidebarSection ({
  renderHeader,
  title,
  description,
  subtitle,
  children,
  menuItems,
  isFirstSection,
  onAllClick,
  selectedItem,
  search,
  filterable,
  filterTitle,
  categoriesLabel,
  hideSearchbar,
  homeSlug,
  sidebarComponent,
  resources = [],
  isOnSidebarContainer,
  renderAs,
  onChange,
  ...others
}) {
  const SidebarComponent = sidebarComponent

  const as = renderAs === 'SubSection' ? SubSection : Section

  return (
    <NoOverflowSection {...others} as={as}>
      <SidebarContainer>
        <SidebarComponent
          renderHeader={renderHeader}
          title={title}
          description={description}
          subtitle={subtitle}
          search={search}
          filterable={filterable}
          menuItems={menuItems}
          selectedItem={selectedItem}
          isPageTitle={isFirstSection}
          onAllClick={onAllClick}
          filterTitle={filterTitle}
          onChange={onChange}
          categoriesLabel={categoriesLabel}
          hideSearchbar={hideSearchbar}
          homeSlug={homeSlug}
        />
        <ChildrenContainer>{children}</ChildrenContainer>
        {resources.length > 0 && (
          <Box>
            <AdditionalResources
              resources={resources}
              isOnSidebarContainer={isOnSidebarContainer}
            />
          </Box>
        )}
      </SidebarContainer>
    </NoOverflowSection>
  )
}

SidebarSection.defaultProps = {
  sidebarComponent: Sidebar,
}

SidebarSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.any.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape(menuItemShape)).isRequired,
  selectedItem: PropTypes.string,
  isFirstSection: PropTypes.bool,
  onAllClick: PropTypes.func,
  search: PropTypes.object,
  filterable: PropTypes.bool,
  filterTitle: PropTypes.string,
  categoriesLabel: PropTypes.string,
  hideSearchbar: PropTypes.bool,
  resources: PropTypes.arrayOf(PropTypes.object),
  isOnSidebarContainer: PropTypes.bool,
}

SidebarSection.defaultProps = {
  categoriesLabel: 'Categories',
  hideSearchbar: false,
}

export default SidebarSection
